'use strict';

import * as domUtils from '../../util/dom';
var device = require('../../util/device');
var Sizzle = require('sizzle');

var NAMESPACE = 'ui-volume-controls';

var CLASSNAMES = {
	volumeContainer: 'svp_js-controls-volume-container',
	volumeButton: 'svp_js-controls-btn--volume',
	volumeLabel: 'svp_ui-controls__volume-label',
	volumeSeekbarContainer: 'svp_js-controls-volume-seekbar-container',
	volumeSeekbar: 'svp_js-controls-volume-seekbar',
	volumeSeekbarProgress: 'svp_js-controls-volume-seekbar--progress',
	volumeSeekbarHandle: 'svp_js-controls-volume-seekbar--progress-handle'
};

var OVERRIDE_CLASSNAMES = {
	volumeSeekbar: 'svp_css-volume--seekbar',
	volumeSeekbarProgress: 'svp_css-volume--seekbar-progress',
	volumeSeekbarHandle: 'svp_css-volume--seekbar-handle'
};

var BUTTON_ICONS = {
	volumeHigher: 'svp_ui-controls__button-volume-high',
	volumeLower: 'svp_ui-controls__button-volume-lower',
	volumeLowest: 'svp_ui-controls__button-volume-lowest',
	muted: 'svp_ui-controls__button-muted'
};

var STATES = {
    focus: 'svp_is--focus'
};

var STORAGE_KEY = 'storedVolume';

var createFn = function (api) {

	function _getElement(className) {
		return api && Sizzle('.' + className, api.element())[0];
	}

	function _adjustVolumeControls() {
		var wantedVolume = api.getVolume(),
			isMuted = api.isMuted(),
			button = _getElement(CLASSNAMES.volumeButton),
			volumeSeekbarProgress = _getElement(CLASSNAMES.volumeSeekbarProgress),
			volumeSeekbar = _getElement(CLASSNAMES.volumeSeekbar),
			volumeSeekbarHandle = _getElement(CLASSNAMES.volumeSeekbarHandle),
			volumeSeekbarContainer = _getElement(CLASSNAMES.volumeSeekbarContainer),
			label = isMuted || wantedVolume === 0 ? 'Ljud på' : 'Ljud av',
			volumeSeekbarHandleOffset,
			wantedClass;

		if (isMuted || wantedVolume === 0) {
			wantedClass = BUTTON_ICONS.muted;
		} else if (wantedVolume < 0.15) {
			wantedClass = BUTTON_ICONS.volumeLowest;
		} else if (wantedVolume < 0.6) {
			wantedClass = BUTTON_ICONS.volumeLower;
		} else {
			wantedClass = BUTTON_ICONS.volumeHigher;
		}

		if (!domUtils.hasClass(button, wantedClass)) {
			domUtils.removeClass(button, [BUTTON_ICONS.volumeLowest, BUTTON_ICONS.volumeLower, BUTTON_ICONS.volumeHigher, BUTTON_ICONS.muted]);
			domUtils.addClass(button, wantedClass);
		}

		//Calculate handler offset, consider radius of the handler and the margin to the container.
		if (volumeSeekbarHandleOffset === undefined) {
			volumeSeekbarHandleOffset = volumeSeekbarContainer.getBoundingClientRect().bottom -
				volumeSeekbar.getBoundingClientRect().bottom -
				(volumeSeekbarHandle.getBoundingClientRect().height / 2);
		}
		var volume = isMuted ? 0 : volumeSeekbar.getBoundingClientRect().height * wantedVolume,
			volumePercent = String(wantedVolume.toFixed(1) * 100);
		volumeSeekbarProgress.style.height = volume + "px";
		volumeSeekbarHandle.style.bottom = volume + volumeSeekbarHandleOffset + "px";

		button.setAttribute('title', label + ' (M)');
		button.setAttribute('aria-valuetext', isMuted ? 0 : volumePercent + '% volym');
		button.setAttribute('aria-valuenow', isMuted ? 0 : volumePercent);
	}

	function _mute(shouldMute) {
		api.mute(shouldMute);

		var storedValue = shouldMute ? 0 : api.getVolume();
		domUtils.setStoredData(STORAGE_KEY, storedValue);
	}

	function _bindVolumeUiInteractionEvents() {
		var volumeButton = _getElement(CLASSNAMES.volumeButton),
            enableVolumeSeekbar = true,
			adjustingSeekbar = false;

		var adjustVolume = function (e) {
			var seekbarRect = _getElement(CLASSNAMES.volumeSeekbar).getBoundingClientRect(),
				volumeSeekbarContainer = _getElement(CLASSNAMES.volumeSeekbarContainer),
				seekbarContainerRect = volumeSeekbarContainer.getBoundingClientRect(),
				seekbarMargin = seekbarContainerRect.bottom - seekbarRect.bottom,
				position = seekbarContainerRect.bottom - e.clientY;

			//adjust position to seekbar; remove margins
			if (position < seekbarMargin) {
				position = seekbarMargin;
			} else if (position > (seekbarMargin + seekbarRect.height)) {
				position = (seekbarMargin + seekbarRect.height);
			}

			var fraction = (position - seekbarMargin) / seekbarRect.height;

			api.setVolume(fraction);
			domUtils.setStoredData(STORAGE_KEY, fraction);

			_adjustVolumeControls();
		};

		var dragEventFn = function (e) {
			adjustVolume(e);
		};

		var dragStartFn = function (e) {
			adjustingSeekbar = true;
			var namespace = NAMESPACE + '-drag',
				mouseupFn = function (e) {
					adjustingSeekbar = false;
					domUtils.removeEvents(document, 'mousemove, mouseup', namespace);
				};

			domUtils.addEvents(document, 'mousemove', dragEventFn, namespace);
			domUtils.addEvents(document, 'mouseup', mouseupFn, namespace);
			e.preventDefault();
			e.stopPropagation();
		};

		var volumeKeyUpHandler = function (e) {
			var keyEvent = domUtils.getKeyFromKeyEvent(e),
				handled = false;

			if (keyEvent === 'enter') {
				_mute(!api.isMuted());
				_adjustVolumeControls();
				handled = true;
			}

			if (handled || keyEvent === 'arrowup' || keyEvent === 'arrowdown') {
				api.fire('showControls', { shouldShow: true });
				e.preventDefault();
				e.stopPropagation();
			}
		};

		var volumeKeyDownHandler = function (e) {
			var keyEvent = domUtils.getKeyFromKeyEvent(e);
            var handled = false;
            var step;
            var newVolume;

			if (keyEvent === 'arrowup' || keyEvent === 'arrowdown') {
				step = keyEvent === 'arrowup' ? 0.1 : -0.1;
				newVolume = Math.max(0, Math.min(1, api.getVolume() + step));
				api.setVolume(newVolume);
				handled = true;
			}

			if (handled || keyEvent === 'enter') {
				e.preventDefault();
				e.stopPropagation();
			}
		};

		var hideVolumeContainer = function () {
			var volumeSeekbarContainer = _getElement(CLASSNAMES.volumeSeekbarContainer);
			if (!adjustingSeekbar && enableVolumeSeekbar) {
				volumeSeekbarContainer.style.visibility = 'hidden';
			}
		};

		var showVolumeContainer = function () {
			var volumeSeekbarContainer = _getElement(CLASSNAMES.volumeSeekbarContainer);
			if (enableVolumeSeekbar) {
				_adjustVolumeControls();
				volumeSeekbarContainer.style.visibility = 'visible';
			}
		};

        var setFocus = function () {
            var volumeContainer = _getElement(CLASSNAMES.volumeContainer);
            domUtils.addClass(volumeContainer, STATES.focus);
            showVolumeContainer();
        };

        var removeFocus = function () {
            var volumeContainer = _getElement(CLASSNAMES.volumeContainer);
            domUtils.removeClass(volumeContainer, STATES.focus);
            hideVolumeContainer();
        };

		domUtils.addEvents(_getElement(CLASSNAMES.volumeSeekbarHandle), 'mousedown', dragStartFn, NAMESPACE);

		domUtils.addEvents(volumeButton, 'mousedown', function (e) {
			e.preventDefault();
		});

		domUtils.addEvents(volumeButton, 'click, touchend', function (e) {
			e.stopPropagation();
			e.preventDefault();
			_mute(!api.isMuted());
			_adjustVolumeControls();
		}, NAMESPACE);

		domUtils.addEvents(volumeButton, 'touchstart', function () {
			enableVolumeSeekbar = false;
			domUtils.hide(_getElement(CLASSNAMES.volumeSeekbarContainer));
		}, NAMESPACE);

		if (!device.isTouch()) {
			domUtils.addEvents(volumeButton, 'mouseenter', showVolumeContainer, NAMESPACE);
		}

		domUtils.addEvents(_getElement(CLASSNAMES.volumeButton), 'focus', setFocus, NAMESPACE);
		domUtils.addEvents(_getElement(CLASSNAMES.volumeButton), 'blur', removeFocus, NAMESPACE);
		domUtils.addEvents(_getElement(CLASSNAMES.volumeContainer), 'mouseleave', hideVolumeContainer, NAMESPACE);
		domUtils.addEvents(_getElement(CLASSNAMES.volumeContainer), 'keyup', volumeKeyUpHandler, NAMESPACE);
		domUtils.addEvents(_getElement(CLASSNAMES.volumeContainer), 'keydown', volumeKeyDownHandler, NAMESPACE);

		// The container listens to click
		domUtils.addEvents(_getElement(CLASSNAMES.volumeSeekbarContainer), 'click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			adjustVolume(e);
		}, NAMESPACE);

		domUtils.addEvents(_getElement(CLASSNAMES.volumeSeekbarContainer), 'mousedown', function (e) {
			e.preventDefault();
			e.stopPropagation();
		}, NAMESPACE);

	}

	return {

		createElement: function () {
			return domUtils.fromString(
				'<div class="svp_ui-controls__volume-container ' + CLASSNAMES.volumeContainer + ' svp_ui-controls--hide-on-error svp_ui-controls--hide-initial">\
					<div class="svp_ui-controls__volume-seekbar-container ' + CLASSNAMES.volumeSeekbarContainer + '">\
						<div class="svp_ui-controls__volume-seekbar ' + CLASSNAMES.volumeSeekbar + ' ' + OVERRIDE_CLASSNAMES.volumeSeekbar + '">\
							<div class="svp_ui-controls__volume-seekbar-progress ' + CLASSNAMES.volumeSeekbarProgress + ' ' + OVERRIDE_CLASSNAMES.volumeSeekbarProgress + '"></div>\
						</div>\
						<div class="svp_ui-controls__volume-seekbar-handle ' + CLASSNAMES.volumeSeekbarHandle + ' ' + OVERRIDE_CLASSNAMES.volumeSeekbarHandle + '"></div>\
					</div>\
					<button class="svp_ui-controls__button-volume-high ' + CLASSNAMES.volumeButton + '" tabindex="0" \
						aria-live="assertive"\
						role="slider"\
						aria-valuemin="0"\
						aria-valuemax="100"\
						aria-valuenow="0"\
						aria-valuetext="0% volym"\
						title="Ljud av">\
						<span class="svp_ui-controls__hidden ' + CLASSNAMES.volumeLabel + '">Volym</span>\
					</button>\
				</div>');
		},

		reset: function () {
			var volumeContainer = _getElement(CLASSNAMES.volumeContainer);

			if (volumeContainer) {
				domUtils.removeClass(volumeContainer, BUTTON_ICONS.fullscreenEnd);
				domUtils.addClass(volumeContainer, BUTTON_ICONS.fullscreen);
			}
		},

		bindEvents: function (api) {
            api.on(NAMESPACE + '.loadedmetadata', () => {
                _adjustVolumeControls();
                api.off(NAMESPACE + '.loadedmetadata');
            });

            api.on(NAMESPACE + '.volumechange', _adjustVolumeControls.bind(this));

			_bindVolumeUiInteractionEvents();

			var storedVolume = domUtils.getStoredData(STORAGE_KEY);
			if (storedVolume !== null && storedVolume !== undefined) {
				if (api.state().ready) {
					if (storedVolume > 0) {
						api.setVolume(storedVolume);
					} else {
						api.mute(true);
					}
				} else {
					api.on(NAMESPACE + '.ready', function () {
						api.off(NAMESPACE + '.ready');
						if (storedVolume > 0) {
							api.setVolume(storedVolume);
						} else {
							api.mute(true);
						}
					});
				}
			}
		}
	};

};

module.exports = {
	create: createFn,
	destroy: function (api) {
		if (api) {
			var element = api.element(),
				volumeContainer = Sizzle('.' + CLASSNAMES.volumeContainer, element)[0],
				currItem;
			if (volumeContainer) {
				for (var className in CLASSNAMES) {
					if (Object.prototype.hasOwnProperty.call(CLASSNAMES, className)) {
						currItem = Sizzle('.' + CLASSNAMES[className], element)[0];
						if (currItem.destroy) {
							currItem.destroy();
						}
					}
				}
				volumeContainer.parentElement.removeChild(volumeContainer);
			}

			api.off(NAMESPACE + '.volumechange');
		}
	}
};




// WEBPACK FOOTER //
// ./src/js/plugins/ui/volume-controls.js